import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef,ElementRef, ViewChild, SimpleChanges } from '@angular/core';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
import { ToastrService } from 'ngx-toastr';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
class DataTablesResponse {
  data: any[];
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-admin-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {
  @ViewChild('fileUploader') fileUploader:ElementRef;
  messagedata:any = [];
  imageurl:any="";
  imagefile:any=null;
  format:any;
  title="";
  submitting=false;

  Form: FormGroup = this.fb.group({
    title: ["", Validators.compose([Validators.required])],
    thumbnail:["", Validators.compose([Validators.required])]
  }); 
  editor:any;

  constructor(private fb: FormBuilder, public adminApi: AdminapiService, private toastrService: ToastrService,public webApi: WebapiService,private store: Store<AppState>){

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.editor){
      this.editor.setContent(this.title);
    }
  }

  handleEvent($event){
    if(!this.editor){
      this.editor=$event.editor
    }
  }

  onSelectFile(event) {
    const file = event.target.files && event.target.files[0];
    if (file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      if(file.type.indexOf('image')> -1){
        this.imagefile=file;
        this.format = 'image';
      }
      reader.onload = (event) => {
        if(this.format=='image'){
          this.imageurl = (<FileReader>event.target).result;
        }
      }
    }
  }

  getThumbUrl(url : string){
    return  "assets/images/"+url
  }

  ngOnInit(): void {
    this.getMessage();
  }

  getMessage(){
    this.adminApi.getMessage().subscribe((data: any) => {
      if (data.success) {
        this.messagedata=data.data;
        this.title = data.data.title;
        if(data.data?.image){
          this.imageurl=this.getImageUrl(data.data.image);
        }
        this.initForm()
      } else {
        alert(data.message)
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  getImageUrl(url : string){
    return  "assets/message_images/"+url
  }

  initForm(){
    this.Form = this.fb.group({
      title: [this.title, Validators.compose([Validators.required])],
      thumbnail: ["", !this.messagedata?.image?Validators.compose([Validators.required]):null],
    });
    
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.submitting) {
      this.submitting = true;
      
      const formData = new FormData();
      formData.append('id', this.messagedata?.id??"");
      formData.append('title', form.value.title);
      formData.append('thumbnail', this.imagefile);
      this.adminApi.saveMessage(formData).subscribe((data: any) => {
        if (data.success) {
          this.fileUploader.nativeElement.value = null;
          $('.selectpicker').selectpicker('refresh');
					this.toastrService.success(data.message);
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } else {
      form.markAllAsTouched();
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.Form.controls;
  }
  
}
